import React from 'react'
import { Fade } from 'react-slideshow-image'
import { graphql } from 'gatsby'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import { Link } from 'gatsby'
import Layout from '../components/Layout'
import Slide from '../components/Slide'
import CoveredText from '../components/CoveredText'
import Helmet from 'react-helmet'
import ItcTriangle from '../components/ItcTriangle'

const IndexPage = ({ data }) => {
  const {
    site: {
      siteMetadata: { toppageTitle, description },
    },
    allMarkdownRemark: { edges },
  } = data

  return (
    <>
      <Helmet>
        <html className="index" lang="ja" />
        <title>{toppageTitle}</title>
        <meta name="description" content={description} />
      </Helmet>
      <Layout>
        <div id="slide">
          <Fade autoplay indicators arrows={false}>
            <Slide>
              <CoveredText>
                <p className="header-title">
                  ロックレスの<p className="sp-only"></p>パイオニア
                </p>
              </CoveredText>
              <picture>
                <source
                  type="image/webp"
                  srcset="/assets/images/common/toppage-slider-01.webp"
                />
                <img
                  className="hero-image"
                  src={`/assets/images/common/toppage-slider-01.jpg`}
                  alt=""
                />
              </picture>
            </Slide>
            <Slide>
              <CoveredText>
                <p className="header-title">
                  AI×ソフトウェアで14万車室以上<sup>*</sup>の
                  <br />
                  ユーザーフレンドリーな駐車場を展開
                  <br />
                  <span className="sup-text">
                    <sup>*</sup>2025年9月現在
                  </span>
                </p>
              </CoveredText>
              <picture>
                <source
                  type="image/webp"
                  srcset="/assets/images/pc/toppage-slider-02.webp"
                />
                <img
                  className="hero-image pc-only"
                  src={`/assets/images/pc/toppage-slider-02.jpg`}
                  alt=""
                />
              </picture>
              <picture>
                <source
                  type="image/webp"
                  srcset="/assets/images/sp/toppage-slider-02.webp"
                />
                <img
                  className="hero-image sp-only"
                  src={`/assets/images/sp/toppage-slider-02.jpg`}
                  alt=""
                />
              </picture>
            </Slide>
            <Slide>
              <CoveredText>
                <p className="header-title">未来の「駐車体験」を形にする</p>
              </CoveredText>
              <picture>
                <source
                  type="image/webp"
                  srcset="/assets/images/common/toppage-slider-03.webp"
                />
                <img
                  className="hero-image"
                  src={`/assets/images/common/toppage-slider-03.jpg`}
                  alt=""
                />
              </picture>
            </Slide>
          </Fade>
        </div>

        <div className="topix-area clearfix">
          <div className="date">{edges[0].node.frontmatter.date}</div>
          <div className="title">
            <Link to={edges[0].node.fields.slug}>
              {edges[0].node.frontmatter.title}
            </Link>
          </div>
          <div className="common-btn">
            <Link to={`/news`}>トピックス一覧</Link>
          </div>
        </div>

        <section className="about">
          <div className="row top">
            <div className="wrapper">
              <div className="blanc-box"></div>
            </div>
          </div>
          <div className="row title">
            <div className="blanc"></div>
            <div className="wrapper">
              <div className="slogan">
                お客様に喜ばれる駐車場を、
                <br />
                一緒に作りましょう
              </div>
            </div>
          </div>

          <div className="row main">
            <div className="container clearfix">
              <div className="border"></div>
              <div className="left-contents">
                <picture>
                  <source
                    type="image/webp"
                    srcset="/assets/images/common/toppage-about.webp"
                  />
                  <img
                    className="pc-only"
                    src={`/assets/images/common/toppage-about.jpg`}
                    alt=""
                  />
                </picture>
                <picture>
                  <source
                    type="image/webp"
                    srcset="/assets/images/sp/toppage-about.webp"
                  />
                  <img
                    className="sp-only"
                    src={`/assets/images/sp/toppage-about.jpg`}
                    alt=""
                    height="173"
                  />
                </picture>
                <div className="shadow"></div>
              </div>

              <div className="right-contents">
                <p>
                  私たちは、車の出し入れ時にロック板に乗り上げなければならないという利用者のストレスを減らすことを目指し、ナンバー認証システムによるロックレス駐車場を開発いたしました。
                  <br />
                  <br />
                  ロックレス駐車場は、不正出庫を減らすことにも寄与し、駐車場運営者の利益を守りながら、利用者にもメリットがある。最も理想的な駐車場システムだと自負しています。
                </p>
                <div className="common-link">
                  <AnchorLink to="/mvv/" title="ミッション・ビジョン・バリュー">
                    ミッション・ビジョン・バリュー
                  </AnchorLink>
                </div>
                <div className="common-link">
                  <Link to={`/service/lockless/`}>
                    ロックレス駐車場について(製品・サービス紹介)
                  </Link>
                </div>
              </div>
              <div className="clear"></div>
            </div>
          </div>
        </section>

        <section className="service">
          <div className="row">
            <div className="h-wrapper">
              <h2>アイテックが提供するサービス</h2>
            </div>
          </div>
          <div className="row itc-triangle pc-only">
            <div className="container">
              <ItcTriangle />
            </div>
          </div>
          {[
            {
              title: '駐車場機器',
              description:
                '大規模運営事業者から小規模オーナーまでニーズに沿った機器を提供',
              to: '/service/equipment/',
            },
            {
              title: 'ソフトウェア',
              description:
                'データとAIで運営を効率化、高度化し、駐車場特有の課題を解決',
              to: '/service/software/',
            },
            {
              title: 'オペレーション',
              description:
                'コールセンター、メンテナンス、不正出庫対応などをノウハウと実績を持って業界最高水準で提供',
              to: '/service/operation/',
            },
          ].map((item) => (
            <div className="row itc-triangle-spreaded sp-only" key={item.title}>
              <div className="container">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <div className="common-btn">
                  <Link to={item.to}>もっと見る</Link>
                </div>
              </div>
            </div>
          ))}
          <div className="row">
            <div className="container contact">
              <div className="border top-left"></div>
              <div className="border top-right"></div>

              <div className="box left">
                <Link to={`/whitepaper`}>
                  <p className="title">製品カタログ ダウンロード</p>
                  <p className="detail">
                    製品・ソリューション、弊社の事例など、
                    <br />
                    お気軽にお問い合わせください。
                  </p>
                  <div className="link-box">ダウンロードページはこちら</div>
                  <div className="shadow sp-only"></div>
                  <div className="blanc sp-only"></div>
                </Link>
              </div>

              <div className="box right">
                <Link to={`/contact/`}>
                  <p className="title">お問い合わせ</p>
                  <p className="detail">
                    お電話、またはお問い合わせフォームより
                    <br />
                    お問い合わせや、ご注文が可能です。
                  </p>
                  <div className="link-box">お問い合わせフォームはこちら</div>
                  <div className="shadow sp-only"></div>
                  <div className="blanc sp-only"></div>
                </Link>
              </div>

              <div className="shadow pc-only"></div>
              <div className="blanc pc-only"></div>
              <div className="border bottom"></div>
            </div>
          </div>
        </section>

        <section className="toppage-content">
          <div className="row">
            <div className="h-wrapper">
              <h2>未来の駐車体験 AI車番認識精算「ナンバーペイ」</h2>
            </div>
          </div>
          <div className="row">
            <div className="container">
              <div className="centerbox">
                <iframe
                  className="center youtube"
                  width="100%"
                  height="100%"
                  src="https://www.youtube-nocookie.com/embed/VxWj0IVQ6ow?si=4MLxD9bP0QHpdaQU&rel=0"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="shadow"></div>
              <div className="right-contents">
                <p>
                  一部対応駐車場にて、ナンバー認証で自動精算が可能です。
                  ナンバーのご登録は、対応駐車場にて一度ナンバーを認証させるだけ。
                  次回利用時から、入庫確認のワンタップのみで精算ができます。
                </p>
                <div className="common-link">
                  <a
                    href="https://apps.apple.com/jp/app/qt-net-%E9%A7%90%E8%BB%8A%E5%A0%B4%E3%83%84%E3%83%BC%E3%83%AB/id563447907"
                    target="_blank"
                    rel="noreferrer"
                  >
                    iOSアプリのダウンロードはこちら
                  </a>
                </div>
                <div className="common-link">
                  <a
                    href="https://play.google.com/store/apps/details?id=jp.co.itechcorp.android.parkingtool&hl=ja"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Androidアプリのダウンロードはこちら
                  </a>
                </div>
              </div>
              <div className="clear"></div>
              <div className="wrapper">
                <div className="link-box">
                  <Link to={`/service/qtnetservice/numberpay`}>
                    ナンバーペイの使い方
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="topics">
          <div className="row">
            <div className="h-wrapper">
              <h2>トピックス</h2>
              <div className="common-btn">
                <Link to={`/news/`}>トピックス一覧</Link>
              </div>
              <div className="border"></div>
            </div>
          </div>
          <div className="row nopadding">
            <div className="topics-wrapper clearfix">
              <div className="left-container">
                {edges.map((aNews) => (
                  <div key={aNews.node.id} className="topic">
                    <div className="wrapper">
                      <p className="date">{aNews.node.frontmatter.date}</p>
                      <p className="title">
                        <Link to={aNews.node.fields.slug}>
                          {aNews.node.frontmatter.title}
                        </Link>
                      </p>
                    </div>
                  </div>
                ))}

                <div className="topic">
                  <div className="wrapper">
                    <div className="link-box">
                      <Link to={`/news/`}>過去のトピックスを見る</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right-container">
                <div className="wrapper">
                  <div className="box comic">
                    <Link to={`/lp/`} className="pc-only">
                      <p>
                        漫画でわかる
                        <br />
                        お客様に喜ばれる
                        <br />
                        快適駐車場の作り方
                      </p>
                      <div className="read">漫画を読む</div>
                    </Link>
                    <p className="sp-only">
                      漫画でわかる
                      <br />
                      お客様に喜ばれる
                      <br />
                      快適駐車場の作り方
                    </p>
                    <div className="link-box sp-only">
                      <Link to={`/lp/`} className="pc-only">
                        漫画を読む
                      </Link>
                    </div>
                    <div className="shadow"></div>
                  </div>
                  <div className="box">
                    <picture>
                      <source
                        type="image/webp"
                        srcset="/assets/images/common/icon-faq.webp"
                      />
                      <img src="/assets/images/common/icon-faq.png" alt="" />
                    </picture>
                    <p>よくある質問</p>
                    <div className="link-box">
                      <Link to={`/faq/`}>詳しく見る</Link>
                    </div>
                    <div className="shadow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default IndexPage

export const query = graphql`
  query NewsIndexQuery {
    site {
      siteMetadata {
        toppageTitle
        description
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "news-template" } } }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 5
      skip: 0
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "YYYY.MM.DD")
          }
        }
      }
    }
  }
`
